import { USERS_GOTTEN } from '../types'
export default function(state = {}, action = {}) {
    switch (action.type) {
        case USERS_GOTTEN:
            return action.users;
        default:
            return state
    }
}